function dashboard(state = {
  dashboard: [],
  warehouse: [],
  warehouse_fetched:false,
  fetching: false,
  fetched: false,
  error: false,
  updateProfile:false,
  updateEmail:false,
  updatePassword:false,
}, action){
  switch (action.type) {
   case 'GET_CUSTOMER_INFO_PENDING':{
        return{
          ...state,
          fetching: true,
        }
      }
      case 'GET_CUSTOMER_INFO_REJECTED':{
        return {
          ...state,
          fetching: false,
          error: action.payload,
          login:[],
        }
      }
      case 'GET_CUSTOMER_INFO_FULFILLED':{
        return{
          ...state,
          fetching: false,
          fetched: true,
          login: action.payload,
        }
      }
      case 'GET_WAREHOUSE_REJECTED':{
        return {
          ...state,      
          error: action.payload,
          warehouse_fetched:false,
          warehouse:[],
        }
      }
      case 'GET_WAREHOUSE_FULFILLED':{
        return{
          ...state,
          warehouse_fetched: true,
          warehouse: action.payload,
        }
      }
        default: break

   }
   return state;
}
export default dashboard;



/** WEBPACK FOOTER **
 ** ./src/reducers/dashboard.js
 **/